import { render, staticRenderFns } from "./Step7.vue?vue&type=template&id=737b6cb9&scoped=true&"
import script from "./Step7.vue?vue&type=script&lang=ts&"
export * from "./Step7.vue?vue&type=script&lang=ts&"
import style0 from "./Step7.vue?vue&type=style&index=0&id=737b6cb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b6cb9",
  null
  
)

export default component.exports